import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, serviceDestination) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/ServiceDestinations`, method: 'POST', body: serviceDestination, token: token })
}
